import { render, staticRenderFns } from "./ObjectLink.vue?vue&type=template&id=726b4697"
import script from "./ObjectLink.vue?vue&type=script&lang=js"
export * from "./ObjectLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports